/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChangeSafePwd.vue?vue&type=template&id=abb94b50&scoped=true&"
import script from "./ChangeSafePwd.vue?vue&type=script&lang=js&"
export * from "./ChangeSafePwd.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSafePwd.vue?vue&type=style&index=0&id=abb94b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb94b50",
  null
  
)

export default component.exports